<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-6">
            <h3>{{ $t("targetgroups") }}</h3>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="index.html">{{ $t("management") }}</a></li>
              <li class="breadcrumb-item active">{{ $t("targetgroup_management") }}</li>
            </ol>
          </div>
          <div class="col-sm-6">
            <!-- Bookmark Start-->
            <div class="bookmark">
              <ul>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                  <form class="form-inline search-form">
                    <div class="form-group form-control-search">
                      <input type="text" :placeholder="$t('search') + '...'">
                    </div>
                  </form>
                </li>
              </ul>
            </div>
            <!-- Bookmark Ends-->
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-9">
          <filter-form :title="targetgroup.id == null ? $t('create_targetgroup') : $t('edit_targetgroup')" v-model="targetgroup" :save="save" :saveable="true"></filter-form>
        </div>
        <div class="col-12 col-md-3">
          <div class="card">
            <div class="card-header pb-0">
              <h5>{{ $t("actions") }}</h5>
            </div>
            <div class="card-body" v-if="editMode">
              <button @click="showDeleteConfirmation = true" class="btn btn-danger" type="button"
                data-bs-original-title="" title="">{{ $t("delete_targetgroup") }}</button>
            </div>
            <div class="card-body" v-else>
              <p>{{ $t("TARGETGROUP_SAVE_BEFORE_DELETE_HINT") }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid Ends-->

      <div class="modal fade show" v-show="showDeleteConfirmation" tabindex="-1" aria-labelledby="exampleModalCenter"
        style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t("delete_targetgroup") }}</h5>
              <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"
                data-bs-original-title="" title="" @click="(showDeleteConfirmation = false)"></button>
            </div>
            <div class="modal-body">
              <p>{{ $t("confirm_delete_targetgroup") }}</p>
            </div>
            <div class="modal-footer">
              <button @click="(showDeleteConfirmation = false)" class="btn btn-secondary" type="button"
                data-bs-original-title="" title="">{{ $t("cancel") }}</button>
              <button @click="deleteTargetGroup()" class="btn btn-danger" type="button" data-bs-dismiss="modal"
                data-bs-original-title="" title="">{{ $t("delete") }}</button>
            </div>
          </div>
        </div>
      </div>

      </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { MapPinIcon, PlusSquareIcon } from 'vue-feather-icons'
import FilterForm from './widget/FilterForm.vue';



export default {

  props: {
    targetgroupId: Number,
  },

  components: {
    apexcharts: VueApexCharts,
    MapPinIcon,
    PlusSquareIcon,
    FilterForm
  },
  data() {
    return {
      editMode: false,

      targetgroup: {
        name: "",//
        tenantId: null,//
        language: "",//
        longitude: "",
        latitude: "",
        radius: 1,
        audienceVehicleMake: null,
        audienceVehicleModel: null,
        audienceVehicleYearFrom: 0,//
        audienceVehicleYearTo: 0,//
        audienceVehicleCount: 0,//
        createdPostsCount: 0,//
        createdTripsCount: 0,//
        memberSince: null,//
        lastCreatedPostFrom: null,//
        lastCreatedPostTo: null,//
        likedHashTags: '',
      },

      fixedTargetGroupAttributes: ["id", "appId", "tenant", "targetAudienceConfiguration", "createdAt", "createdBy", "editedAt", "editedBy", "longitude", "latitude", "radius", "deleted", "name", "app", "createdAtFormatted", "editedAtFormatted", "tenantId"],

      showDeleteConfirmation: false,


      languages: [],
      possiblelanguages: [],
      tenants: [],
      makes: [],
      models: [],
      apps: [],

      map: {
        center: {
          latitude: 0,
          longitude: 0
        },
        zoom: 10,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        markers: []
      },

      boundaries: [],
    };
  },
  created() {

    if (this.targetgroupId != null) {
      this.editMode = true;
      this.fetchEditingTargetGroup();
    } else {
      navigator.geolocation.getCurrentPosition((loc) => {
        this.map.center.latitude = loc.coords.latitude;
        this.map.center.longitude = loc.coords.longitude;
      })
    }
  },

  mounted() {
    this.fetchTenants();
    this.fetchLanguages();
  },

  methods: {
    _validate(obj) {
      if (obj.names == {}) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("designation") }));
        return false;
      }

      return true;
    },
    addMarker(event) {
      if (this.map.markers.length >= 1) { this.removeMarker() }
      this.map.markers.push(event.latlng);

    },
    removeMarker() {
      this.map.markers.splice(0, 1);
    },
    fetchEditingTargetGroup() {
      var _this = this;
      this.$axios
        .get("/api/targetaudience/" + this.targetgroupId)
        .then(function (response) {
          _this.targetgroup = response.data;
          const targetAudienceConfiguration = JSON.parse(_this.targetgroup.targetAudienceConfiguration);
          for (const [key, value] of Object.entries(targetAudienceConfiguration)) {
            if(_this.fixedTargetGroupAttributes.includes(key)) continue;
            _this.targetgroup[key] = value;
          }
          console.log(_this.targetgroup);
          if (_this.targetgroup.latitude != null && _this.targetgroup.longitude != null) {
            _this.addMarker({ latlng: { lat: _this.targetgroup.latitude, lng: _this.targetgroup.longitude } })
            Vue.nextTick(() => {
              _this.map.center.latitude = _this.targetgroup.latitude;
              _this.map.center.longitude = _this.targetgroup.longitude;
            });
          } else {
            navigator.geolocation.getCurrentPosition((loc) => {
              _this.map.center.latitude = loc.coords.latitude;
              _this.map.center.longitude = loc.coords.longitude;
            })
          }
        })
        .catch(this.onError);
    },
    fetchLanguages(resetPage = false) {
      var _this = this;
      this.$axios
        .get("/api/language/all")
        .then(function (response) {
          _this.languages = response.data;
          _this.convertLanguages(_this.languages)
          _this.$forceUpdate();

        })
        .catch(this.onError);
    },
    convertLanguages(languages) {
      const lnlist = [];
      for (var i in languages) {
        var language = {};
        var ln = languages[i].language;

        // console.log(this.$t(languages[i].language));
        language.enum = languages[i].language;
        language.name = this.$t(languages[i].language);
        language.flag = languages[i].flag;
        language.shortForm = languages[i].shortForm;
        lnlist.push(language);

      }
      this.possiblelanguages = lnlist;
    },
    fetchTenants(resetPage = false) {
      var _this = this;
      this.$axios
        .get("/api/tenant")
        .then(function (response) {
          _this.tenants = response.data.content;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    // fetchApps(search = ""){
    //   if(search == null) return;
    //   var _this = this;
    //   progressIndicator.hidden = false;
    //   this.$axios
    //     .get("/api/app?size=50&search=" + search)
    //     .then(function (response) {
    //       if(_this.tenants.length == 0) _this.tenants = response.data.content;
    //       for (let i = 0; i < response.data.content.length; i++) {
    //         const tenant = response.data.content[i];
    //         if(_this.tenants.filter(t => { return t.name == tenant.name }).length == 0){
    //           _this.tenants.push(tenant);
    //         }
    //       }

    //       if(_this.tenantId != null){
    //         // Remove Tenant which is being edited (no self-adding)
    //         for (let i = _this.tenants.length - 1; i >= 0; i--) {
    //           const tenant = _this.tenants[i];
    //           if(tenant.id == _this.tenantId){
    //             _this.tenants.splice(i, 1);
    //           }
    //         }
    //       }
    //       _this.$forceUpdate();
    //     })
    //     .catch(this.onError)
    //     .finally(this.finalize);
    // },
    save(obj) {
      if (!this._validate(obj)) return;
      var targetgroup = Object.assign({}, obj);
      // targetgroup.tenantId = obj.tenant.id == undefined ? obj.tenant : obj.tenant.id;
      // if (typeof targetgroup.likedHashTags === 'string' || targetgroup.likedHashTags instanceof String) targetgroup.likedHashTags = obj.likedHashTags.split(',');
      // targetgroup.longitude = this.map.markers[0] == undefined ? null : this.map.markers[0].lng;
      // targetgroup.latitude = this.map.markers[0] == undefined ? null : this.map.markers[0].lat;

      delete targetgroup.app;
      const targetAudienceConfiguration = Object.assign({}, obj);
      for (let i = 0; i < this.fixedTargetGroupAttributes.length; i++) {
        const attr = this.fixedTargetGroupAttributes[i];
        delete targetAudienceConfiguration[attr];
      }
      if(targetAudienceConfiguration.audienceVehicleMake == null) targetAudienceConfiguration.audienceVehicleModel = null;
      targetgroup.targetAudienceConfiguration = JSON.stringify(targetAudienceConfiguration);

      if (this.editMode) {
        this.updateTargetGroup(targetgroup);
      } else {
        this.createTargetGroup(targetgroup);
      }
    },
    createTargetGroup(targetgroup) {
      var _this = this;
      this.$axios
        .post("/api/targetaudience", targetgroup)
        .then(function (response) {
          _this.$noty.success(_this.$t("targetgroup_created"));
          _this.$router.push("/targetgroups");
        })
        .catch(this.onError);
    },
    updateTargetGroup(targetgroup) {
      var _this = this;
      this.$axios
        .put("/api/targetaudience/" + this.targetgroupId, targetgroup)
        .then(function (response) {
          _this.$noty.success(_this.$t("targetgroup_edited"));
          _this.$router.push("/targetgroups");
        })
        .catch(this.onError);
    },
    deleteTargetGroup() {
      var _this = this;
      this.$axios
        .delete("/api/targetaudience/" + this.targetgroupId)
        .then(function (response) {
          _this.showDeleteConfirmation = false;
          _this.$noty.success(_this.$t("targetgroup_deleted"));
          _this.$router.push("/targetgroups");
        })
        .catch(this.onError);
    },
    logError(error) {
      console.log(error);
    },
    onError(error) {
      console.log(error);
    },
    finalize() {
      progressIndicator.hidden = true;
    }
  },
};
</script>

<style>
label {
  font-size: 12px;
}

.align {
  align-items: self-end;
  display: flex;
}

input {
  height: 40px;
}
</style>